import { useEffect, useState } from 'react';
import { Link } from 'react-router';
import { NoteLine } from '../../components/Lines';
import { t } from '../../i18n';
import { useMember, useSession } from '../../session';
import { FROM_PROFILE } from './ProfilePassword';
import { Settings } from './Settings';

/**
 * The Profile tab (A6; D26), at /profile: the member's display name and username, who changes them
 * (an admin on their own page in Members; a member asks an admin, the owner's answer), the way to
 * change the password, and Settings with its rows to come.
 */
export function Profile() {
  const member = useMember();
  const { passwordChanged, forgetPasswordChanged } = useSession();
  // Said once: the session forgets it at once, so coming back here doesn't say it again.
  const [said] = useState(passwordChanged);

  useEffect(() => {
    if (said) forgetPasswordChanged();
  }, [said, forgetPasswordChanged]);

  return (
    <section className="screen screen-narrow">
      <h1>{t('nav.profile')}</h1>
      <NoteLine text={said ? t('profile.passwordChanged') : undefined} />
      <dl className="profile-card">
        <div>
          <dt>{t('profile.displayName')}</dt>
          <dd>{member.displayName}</dd>
        </div>
        <div>
          <dt>{t('profile.username')}</dt>
          <dd>{member.username}</dd>
        </div>
      </dl>
      {member.role === 'admin' ? (
        <Link to={`/admin/members/${encodeURIComponent(member.id)}`} className="text-link">
          {t('profile.editInMembers')}
        </Link>
      ) : (
        <p className="muted">{t('profile.askAdmin')}</p>
      )}
      <div className="stack">
        {/* Marked, so the change goes back to this Profile rather than adding another (D28). */}
        <Link to="/profile/password" state={FROM_PROFILE} className="button button-secondary">
          {t('profile.changePassword')}
        </Link>
      </div>
      <Settings />
    </section>
  );
}
